import { Avatar, Box, Typography, Stack } from '@mui/material';
import { getInitials } from '../../utils/helper';
import dayjs from 'dayjs';
import { sxConfig } from './comment.style';
import useUsers from '../../context/UsersContext';
import CommentMessageField from './CommentMessageField';
import { ButtonUI } from '../Interface';

const CommentCard = ({ comment, handleRemove, handleStartEdit, handleUpdate, editingState }) => {
  const { editing, setEditing } = editingState;
  const { user } = useUsers();

  return (
    <Box sx={sxConfig.root}>
      <Box sx={sxConfig.row}>
        <Avatar sx={sxConfig.avatar}>{getInitials(comment.user?.nickName)}</Avatar>
        <Box sx={sxConfig.contentWrapper}>
          <Box sx={sxConfig.header}>
            <Typography sx={sxConfig.userName}>{comment.user?.nickName}</Typography>
            <Stack direction="row" gap={1}>
              <Typography sx={sxConfig.date}>{dayjs(comment.createdAt).format('YYYY-MM-DD HH:mm')}</Typography>
              <Typography sx={sxConfig.edited}>{comment.updatedBy && '(szerkesztve)'}</Typography>
            </Stack>
          </Box>
          <Box sx={sxConfig.messageBox}>
            {comment.id === editing?.id ? (
              <CommentMessageField
                onChange={(e) => setEditing((prev) => ({ ...prev, message: e.target.value }))}
                value={editing.message}
              />
            ) : (
              <Box sx={sxConfig.messageBoxText}>
                <Typography>{comment.message}</Typography>
              </Box>
            )}
          </Box>

          {comment.id === editing?.id ? (
            <Box sx={sxConfig.buttonWrapper}>
              <ButtonUI
                text="Mentés"
                className="bg-[#669DF1] mt-2"
                size="sm"
                disabled={!editing.message.trim().length > 0}
                onClick={handleUpdate}
              />
              <ButtonUI
                text="Módosítások elvetése"
                className="bg-[#949494] mt-2"
                size="sm"
                onClick={() => setEditing(null)}
              />
            </Box>
          ) : (
            comment.createdBy === user.userId && (
              <Box sx={sxConfig.actions}>
                <Typography sx={sxConfig.actionText} onClick={() => handleStartEdit(comment)}>
                  Szerkesztés
                </Typography>
                <Typography sx={sxConfig.actionText} onClick={() => handleRemove(comment.id)}>
                  Törlés
                </Typography>
              </Box>
            )
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default CommentCard;
